import Api, { ApiOptions } from '@op/opds.api-base';
import { ServicePlanId } from '../common';
import { v4 } from 'uuid';

const headers = { 'x-session-id': v4(), 'x-request-id': v4() };

export class ServicePlansInfoApi extends Api {
  static PATH = window.env.CONTEXT_PATH || '/service-plans/v1/service-plans';

  constructor(root: string = '', options?: ApiOptions) {
    super(root + ServicePlansInfoApi.PATH, Object.assign({}, { headers }, options));
  }

  public getServicePlan = async (servicePlanId: ServicePlanId): Promise<string> => {
    return await this.get(`/${servicePlanId}`);
  };

  public getServicePlans = async () => {
    return await this.get(`/`);
  };
}
